export const COURSE_COLORS = [
  '#2185d0', '#21ba45', '#f2711c', '#fbbd08', '#e03997',
  '#a333c8', '#00b5ad', '#b5cc18', '#767676', '#1b1c1d',
];

export const INITIAL_STATE = {
  'id': '',
  'fechaInicio': '',
  'fechaHasta': '',
  'fechaLimiteInscripcion': '',
  'fechaLimitePrimeraEvaluacion': '',
  'idCursoReferencia': '',
  'instructor': '',
  'dirigidoA': [],
  'tiempoExperiencia': 0,
  'estado': '',
  'descripcion': '',
  'numParticipantes': 0,
};
/* eslint-disable max-statements */
export const getInlineErrors = (data) => {
  const errors = {};
  const fIn = data.fechaInicio ? new Date(data.fechaInicio) : null;
  const fOut = data.fechaHasta ? new Date(data.fechaHasta) : null;
  const fIns = data.fechaLimiteInscripcion ? new Date(data.fechaLimiteInscripcion) : null;
  const fEv = data.fechaLimitePrimeraEvaluacion ? new Date(data.fechaLimitePrimeraEvaluacion) : null;

  if (fIn && fIn.getFullYear() > 2100) {
    errors.fechaInicio = 'Año no válido';
  }
  if (fIn && fIns && fIns > fIn) {
    errors.fechaLimiteInscripcion = 'No puede ser posterior al inicio';
  }
  if (fIn && fOut && fOut < fIn) {
    errors.fechaHasta = 'No puede ser antes del inicio';
  }
  if (fIns && fEv && fEv < fIns) {
    errors.fechaLimitePrimeraEvaluacion = 'No puede ser antes de la inscripción';
  }
  if (fIn && fEv && fEv > fIn) {
    errors.fechaLimitePrimeraEvaluacion = 'No puede ser posterior al inicio';
  }
  return errors;
};

export const formatAgendaData = (formData, areaId, instructorId) => {
  const payload = {
    'estado': formData.estado,
    'fecha_desde': formData.fechaInicio,
    'fecha_evaluacion': formData.fechaLimitePrimeraEvaluacion,
    'fecha_hasta': formData.fechaHasta,
    'fecha_inscripcion': formData.fechaLimiteInscripcion,
    'formulario': instructorId,
    'id_area': areaId,
    'id_curso': Number(formData.idCursoReferencia),
    'observacion': formData.descripcion,
    'participantes': formData.numParticipantes,
  };

  if (formData.id) {
    payload.id = Number(formData.id);
  }

  return payload;
};

export const distributeParticipants = (total, list) => {
  const n = (list || []).length;
  if (n === 0) {
    return [];
  }

  const currentSum = (list || []).reduce((acc, d) => {
    const val = Number(d.count) || Number(d.participantes) || 0;
    return acc + val;
  }, 0);

  if (currentSum === Number(total) && total > 0) {
    return list.map((d) => ({
      ...d,
      'count': Number(d.count) || Number(d.participantes) || 0,
    }));
  }

  const base = Math.floor(total / n);
  const rem = total % n;
  return list.map((d, i) => ({
    ...d,
    'count': i < rem ? base + 1 : base,
  }));
};
